import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { ActionType, ConstantService, RootsActionMenuItem, RootsPageComponentConfig } from "../../../shared";
import { Router } from "@angular/router";
import { SnackService } from "../../../shared/services/extra/snack.service";
import { ReportsService } from "../../../shared/services/reports.service";
import { SensorLogs } from "../../../shared/classes/sensorlog";
import {
  SensorDialogComponent,
} from "../../../shared/components/dialogs";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatDialog } from "@angular/material/dialog";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { SearchBarService } from "../../../shared/services/searchbar.service";
import { RootsTableInterface } from "../../../shared/components/roots-table/roots-table.interface";
import { Subscription } from "rxjs";

@Component({
  selector: "app-sensorreport",
  templateUrl: "./sensorreport.component.html"
})
export class SensorreportComponent implements RootsTableInterface, OnInit, OnDestroy {
  dateNow = new Date(Date.now());
  dateFrom = new Date();
  selectedTime;
  datePickerTime: Date;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Output() scoutDirect = new EventEmitter<any>();
  daysBack = 7;
  sensorLogs: SensorLogs[] = [];
  jwt: any;
  sensors: any[] = [];
  _config: RootsPageComponentConfig = {
    loading: true,
    title:'',
    toolTip:'',
    dataSource: new MatTableDataSource<SensorLogs>(),
    displayedColumns: [
      "sensorBasicName",
      "scoutBasicName",
      "customerBasicName",
      "date",
      "lastSensorData"
    ],
    message: ''
  };
  actionButtons: RootsActionMenuItem[] = [
    {
      name: "Query DateTime",
      icon: "add",
      toolTip:
        "Create new TestSensor in db - this will be flagged for incoming scout logs",
      type: ActionType.Dialog,
    }
  ];
  items: RootsActionMenuItem[] = [
    {
      name: "View Last Sensor Data",
      toolTip:
        'View last sensor data received foreach sensor',
      icon: "search",
      type: 10,
    }
  ];
  componentSubscription: Subscription;
  searchSubscription: Subscription;
  constructor(
    private _constService: ConstantService,
    private _router: Router,
    public _dialog: MatDialog,
    private _snack: SnackService,
    private _reportService: ReportsService,
    public searchBarService: SearchBarService
  ) {
    this._config.title = 'Sensors Report';
    this._config.toolTip = 'Sensors section provides valuable insights into the last reported data from currently active sensors';
  }

  async ngOnInit(): Promise<void> {
    //from
    const from = this.dateFrom.setDate(this.dateFrom.getDate() - this.daysBack);
    const f = new Date(from);
    const ut = this._constService.convertDateUTC(f);

    await this.showSensorLogList();
    if (this._config.loading) {
      this._snack.displayLoading("Sensor report loading...");
    }
    this.searchSubscription = this.searchBarService.currentMessage.subscribe(message => {
      this._config.message = message;
    })
  }

  ngAfterViewInit() {
    this._config.dataSource.sort = this.sort;
    this._config.dataSource.paginator = this.paginator;
  }

  ngOnDestroy() {
    if (this.componentSubscription) {
      this.componentSubscription.unsubscribe();
    }
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this._dialog) {
      this._dialog.ngOnDestroy();
    }
  }

  
topMenuActionsClicked(action) {
  switch (action.type) {
    case 3:
      break;
    default:
      break;
  }
}

  async showSensorLogList(): Promise<void> {
    const requestId = "";
    this.componentSubscription = this._reportService.getAdminReportSensorLogs().subscribe((reportLog) => {
      console.log(reportLog);
      this._snack.displayLoading("Loading Sensors");
      this.sensorLogs = reportLog;
      this._config.dataSource.data = this.sensorLogs as SensorLogs[];
      this._config.dataSource.data = this._config.dataSource.data.sort((a, b) => {
        return new Date(a.date).getUTCFullYear < new Date(b.date).getUTCFullYear
          ? -1
          : new Date(a.date).getUTCFullYear > new Date(b.date).getUTCFullYear
          ? 1
          : 0;
      });
      if (this.sensorLogs !== null || this.sensorLogs !== undefined) {
        this.grabDate();
        this._config.loading = false;
        this._snack.displayLoading("Sensor report loaded");
      }
      setTimeout(() => (this._config.dataSource.paginator = this.paginator));
      //reFilter();
    });
  }

  actionsClicked(action) {
    const type = action[0];
    const item = action[1];
    switch (type.type) {
      case 10:
        this._config.loading = true;
        this.logDialog(item);
      break;
      default:
        break;
    }
  }  

  grabDate() {
    if (this._config.dataSource.data !== null || this._config.dataSource.data !== undefined) {
      for (let i = 0; i < this._config.dataSource.data.length; i++) {
        const sensor = this._config.dataSource.data[i];
        if (
          sensor.lastSensorData !== null ||
          sensor.lastSensorData !== undefined
        ) {
          const jwt = JSON.parse(sensor.lastSensorData);
          const readings: any[] = [];
          readings.push(jwt.Readings);
          sensor.readings = readings[0];
          sensor.date = jwt.Date;
        }
      }
    }
  }

  refresh($event) {
    this._config.loading = true;
    this.showSensorLogList();
  }

  dateChange(event: any) {
    console.log(event);
    this.daysBack = event.daySpan;
    const sDate = this._constService.convertDateUTC(event.startDate);
    const eDate = this._constService.convertDateUTC(event.endDate);
    this.showSensorLogList();
  }

  navigateToSensorDetails(sensorId: string) {
    console.log(sensorId);
    this._router.navigate([`/assets/${sensorId}/assets`]);
  }

  logDialog(log: SensorLogs): void {
    const dialogRef = this._dialog.open(SensorDialogComponent, {
      width: "50vw",
      height: "75vh",
      data: [log.readings, log.date, log.sensorBasicName],
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        console.log(result + " : report viewed");
      }
    });
  }
}
